var
    /**
     *
     * @type {string[]}
     */
    GET_MODELS_FIELDS = [
        'id',
        'name',
        'niceId',
        'modelYears(id,year)'
    ],
    /**
     *
     * @type {string[]}
     */
    GET_SUBMODELS_FIELDS = [
        'id',
        'name',
        'niceId',
        'makeName',
        'makeNiceName',
        'modelName',
        'modelNiceId',
        'year',
        'publicationStates'
    ],

    /**
     *
     * @type {string}
     */
    DEFAULT_SORT_FIELD = 'name',

    /**
     *
     * @type {string}
     */
    DEFAULT_MODEL_STATES = 'NEW',

    /**
     * Page number for models / submodels request
     * @type {number}
     */
    PAGE_NUM = 1,

    /**
     * Page size for models / submodels request
     * @type {number}
     */
    PAGE_SIZE = 1500; // - why 1500? - more details you can have a look here: https://edmunds.atlassian.net/browse/FIND-2846


module.exports = {

    /**
     * Retrieves complete model list
     *
     * api/vehicle/v3/models?makeNiceId=aston-martin&fields=id,name,niceId,modelYears(id,year)&sortby=name&publicationStates=NEW,NEW_USED
     *
     * E.g. qa-11-www.edmunds.com/api/vehicle/v3/models?
     *   makeNiceId=aston-martin&
     *   fields=id,name,niceId,modelYears(id,year)&
     *   sortby=name&publicationStates=NEW,NEW_USED
     *
     * @param {string} makeNiceId
     * @param {string} sort
     * @param {string} states
     * @return {*}
     */
    getModelsYearsByMake: function (makeNiceId, sort, states) {
        return $.getJSON(
            '/api/vehicle/v3/models/',
            {
                makeNiceId: makeNiceId,
                fields: GET_MODELS_FIELDS.join(','),
                sortby: sort ? sort : DEFAULT_SORT_FIELD,
                publicationStates: states ? states : DEFAULT_MODEL_STATES,
                pagenum: PAGE_NUM,
                pagesize: PAGE_SIZE
            }
        ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
            return Array.isArray(response)? response : response.results;
        }).then(function (modelsYearsList) {
            return modelsYearsList.map(function (modelYears) {
                modelYears.years = modelYears.modelYears.reduceRight(function (yearsList, yearObject) {
                    return yearsList.push(yearObject.year) && yearsList;
                }, []);
                return modelYears;
            });
        });
    },
    /**
     * Retrieves complete submodels list
     *
     * api/vehicle/v3/submodels?makeNiceName=acura&sortby=name&publicationStates=NEW
     *
     * E.g. qa-11-www.edmunds.com/api/vehicle/v3/submodels?makeNiceName=acura&sortby=name&publicationStates=NEW
     *
     * @param {string} make
     * @param {string} sort
     * @param {string} states
     * @return {*}
     */
    getSubmodelsYearsByMake: function (makeNiceId, sort, states) {
        return $.getJSON(
            '/api/vehicle/v3/submodels',
            {
                makeNiceId: makeNiceId,
                fields: GET_SUBMODELS_FIELDS.join(','),
                sortby: sort ? sort : DEFAULT_SORT_FIELD,
                publicationStates: states ? states : DEFAULT_MODEL_STATES,
                pagenum: PAGE_NUM,
                pagesize: PAGE_SIZE
            }
        ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
            return Array.isArray(response)? response : response.results;
        });
    },

    /**
     * Getting price & detailed information for a specific style
     * E.G. //www.edmunds.com/api/vehicle/v3/styles?id=100812301
     *
     * @param {string} styleId
     * @param {string} publicationState
     * @param {string} year
     * @return {*}
     */

    getVehicleByStyleId: function(styleId,publicationState,year){return $.getJSON(
        '/api/vehicle/v3/styles',
        {
            id: styleId,
            publicationState:publicationState,
            year: year
        }
    ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
        return Array.isArray(response)? response : response.results;
    });
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/data/vehicle-endpoint.js
// module id = 49
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14